import { Suspense, lazy } from 'react';
import { Navigate, Outlet, RouteObject } from 'react-router';

import { accountRoutes } from '@fly/features/account';
import { decisionRecordsRoutes } from '@fly/features/decision-records/routes';
import { registryRoutes } from '@fly/features/registry';
import { environmentsRoutes } from '@fly/features/runtime-environments';
import { routes } from '@fly/shared';
import { FlyNotFound, FlyOidcSecure } from '@fly/shared-ui';

const Dashboard = lazy(() => import('./Dashboard'));

/*
* TODO when done with Electron login need to check if
  OidcSecure needed only in webapp
* */
export const dashboardRoutes: RouteObject[] = [
  {
    element: (
      <FlyOidcSecure>
        <Suspense>
          <Dashboard />
        </Suspense>
      </FlyOidcSecure>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={routes.DASHBOARD.ROOT} replace />,
      },
      ...registryRoutes,
      ...decisionRecordsRoutes,
      ...accountRoutes,
      {
        element: <Outlet />,
        children: environmentsRoutes,
      },
      { path: 'forbidden', element: <div>Forbidden</div> },
      { path: '*', element: <FlyNotFound /> },
    ],
  },
];
